export default __webpack_public_path__ + "debe824d717bd2068f6b28bb22724ecc.png";